import { makeStyles, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import Img from "react-cool-img";
import { useHistory } from "react-router-dom";
import earn from "../../../assets/staticAssets/earn_2.svg";

function LandingPageEighthSection() {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className=" pb-20 md:mb-0 md:-mt-32 overflow-hidden bg-gradient-to-b from-[#131517]">
      <div className="container-bt">
        <div className="flex justify-between flex-wrap items-center">
          {" "}
          <div className="md:w-[50%] relative">
            <Img
              className="w-full md:max-w-[500px] "
              src={
                require("../../../assets/optimized/Landing/Refer and Earn Section/referSectionImage.svg")
                  .default
              }
            />
          </div>{" "}
          <div className="md:w-[50%] leading-relaxed -mt-10 md:-mt-0">
            <h1 className="font-extrabold">
              Refer Friends and{" "}
              <span className="text-pb-primary-100">
                Earn <br className="md:block hidden"></br>Rewards!
              </span>
            </h1>
            <br></br>
            <p
              className="font-light text-lg md:text-xl leading-loose mb-10"
              style={{ color: "#ccc" }}
            >
              Help your friends trade with unlimited{" "}
              <span className="text-pb-primary-100">Zero-Fees</span> on
              PocketBits. Earn <span className="text-pb-primary-100">0.1%</span>{" "}
              rewards on each of their trades.
            </p>
            <div
              className="flex items-center gap-x-2 bg-pb-primary-100 py-4 px-4 rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer mt-5"
              onClick={() => {
                history.push("/invite");
              }}
            >
              <img
                src={
                  require("../../../assets/optimized/Landing/Hero Section/Navbar Icons/signIn-icon.svg")
                    .default
                }
              ></img>
              REFER NOW
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({}));
export default LandingPageEighthSection;
